<template>
    <div class="comp-product-list">
        <launch-app :type="type" :params="appParams">
            <ul class="product-page ui-row mt-4 flex pl-4 pr-4"
                id="productsList"
                v-if="list.length > 0"
                style="flex-wrap: wrap">
                <li class="product-page-item"
                    :id="product.productGuid"
                    :data-currency-code="product.currencyCode"
                    v-for="(product,index) in list" >
                    <div class="text-center bottom-shadow item-inner">
                        <img v-if="product.pictureUrl" :src="product.pictureUrl" :style="{'height':cardWidth +'px'}">
                        <img v-if="!product.pictureUrl" src="../image/no-image.png" alt="image" :style="{'height': cardWidth + 'px'}">
                        <div class="product-page-info flex-1 flex-col">
                            <div class="tw-prod-name overflow text-left">{{product.Name}}</div>
                            <div class="text-left mt-3 pb-4 flex-1 flex-col"  style="justify-content: flex-end">
                                <p v-if="product.freeOffer" class="text-left text-green text-b" data-i18n-text="limitFreeProductAdd"></p>
                                <div v-if="!product.freeOffer" style="height: 28px;">
                                    <i class="icon iconfont icon-wodeCOIN small" v-if="!appleCheck"></i>
                                    <i class="text-blue" v-if="appleCheck">$</i>
                                    <span class="price text-blue"> {{product.tweebuckPrice | ifNull}}</span>
                                    <span class="text-bottom">{{message[language].tweebucks}}</span>
                                    <span class="text-bottom ml-2">{{$util.getExchangeText(product.tweebuckPrice)}}</span>
                                    <span class="pull-right x-small pr-3 text-light-gray" >
                                        <i class="icon iconfont icon-wenben" v-if="product.hasTycoonOwnerComment"></i>
                                        <i class="icon iconfont icon-tupian1" v-if="product.hasTycoonOwnerComment_Pics"></i>
                                        <i class="icon iconfont icon-shipin" v-if="product.hasTycoonOwnerComment_Video"></i>
                                    </span>
                                </div>
                                <div style="height: 20px">
                                    <span v-if="!product.active" class="x-small bk-red text-white pl-2 pr-2 mr-2 pull-left" style="display: inline-block;border-radius: .2rem">{{message[language].discontinue}}</span>
                                    <span v-if="product.productType === 2" class="x-small bk-light-blue text-white pl-2 pr-2 mr-2 pull-left" style="display: inline-block;border-radius: .2rem">{{message[language].digital}}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </li>
            </ul>
            <no-data v-if="list.length === 0"></no-data>
        </launch-app>
    </div>
</template>
<script>
    import LaunchApp from './LaunchApp.vue';
    import NoData from './NoData.vue';
    export default {
        props: {
            list: {
                type: Array,
                default: []
            },
            type: {
                type: String,
                default: 'space'
            },
            appParams: {
                type: String,
                default: ''
            }
        },
        components: {
            LaunchApp,
            NoData
        },
        filters: {
            formatTime:function (value) {
                return moment.utc(value).local().format('YYYY-MM-DD HH:mm');
            },
            ifNull:function (value) {
                if(!value){
                    return 0 ;
                }else{
                    return value;
                }
            }
        },
        mounted() {
            this.$util.initRate();
        },
        data() {
            return {
                appleCheck: false,
                cardWidth: (document.body.clientWidth - 30) / 2,
                message: {
                    en: {
                        "digital": "Digital",
                        "discontinue": "Discontinue",
                        "tweebucks": "T-Beans"
                    },
                    zh: {
                        "digital": "数字产品",
                        "discontinue": "下架",
                        "tweebucks": 'T豆'
                    }
                }
            }
        },
        methods: {

        }
    }
</script>
<style lang="less">
    .comp-product-list {
        background-color: #fafafa;
        .overflow {
            overflow : hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
        }
        .bk-light-blue {
            background-color: #4578F3;
        }
        .product-page li{
            box-sizing: border-box;
            width: 49%;
            margin-bottom: 1rem;
            background-color: #fff;
            .item-inner {

            }
        }
        .product-page li:nth-child(2n) {
            margin-left: 0.5%;
        }
        .product-page li:nth-child(2n+1) {
            margin-right: 0.5%;
        }
        .product-page img{
            width: 100%;
            align-self: center;
            object-fit: cover;
        }
        .product-page-info {
            padding: 0 1rem;
        }
    }
</style>
